import Main from 'layouts/Main';
import { Content, Headline, TutorialVideo } from './components';

const AbstractsSubmissionPage = () => {
    return (
        <Main>
            <Headline />
            <TutorialVideo />
            <Content />
        </Main>
    );
};

export default AbstractsSubmissionPage;
